import React from 'react'
import { View, Text } from 'react-native'
import Colors from '../../../constants/Colors';
import CS from '../../../constants/Styles';
import Button from '../../../components/Button';
import UserAvatar from '../../../components/Users/UserAvatar';
import styles from './styles';
import { formatCurrency } from '../../../utils/Functions';

export const MilestoneChange = ({ item, acceptChange, rejectChange }) => {

  const accept = () => {
    console.log('accept()');
    acceptChange(item);
  }
  const reject = () => {
    console.log('reject()');
    rejectChange(item);
  }

  return (
    <View>
      {/* <Text style={[CS.smallTitle, CS.lightText]}>Milestone</Text> */}
      <View style={[CS.rowContainer, { marginBottom: 20 }]}>
        <UserAvatar userId={item.avatar.id} avatar={item.avatar.version} size='medium' />
        <Text style={[CS.smallText, CS.lightBlueText, { marginLeft: 10 }, CS.flex]}>{item.memo}</Text>
      </View>
      <Text style={[CS.smallText, CS.lightBlueText, CS.boldText, { marginBottom: 10 }]}>From</Text>
      {item.old_value.map(m => 
        (
        <View style={styles.milestone} key={`old${m.stage_id}`}>
          <Text style={[CS.mediumText, CS.boldText, CS.lightBlueText, { marginBottom: 10 }]}>{m.title}</Text>
          {m.description !== ""
            ?
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>{m.description}</Text>
            : null
          }
          <Text style={[CS.mediumText, CS.boldText, CS.lightBlueText]}>{m.direction} {formatCurrency(m.amount)}</Text>
        </View>
        )  
      )}
      <Text style={[CS.smallText, CS.lightBlueText, CS.boldText, { marginBottom: 10 }]}>To</Text>
      {item.new_value.map(m =>
      (
        <View style={[styles.milestone, styles.newMilestone]} key={`new${m.stage_id}`}>
          <Text style={[CS.mediumText, CS.boldText, CS.blueText, { marginBottom: 10 }]}>{m.title}</Text>
          {m.description !== "" ?
            <Text style={[CS.smallText, CS.blueText, { marginBottom: 10 }]}>{m.description}</Text>
            : null
          }
          <Text style={[CS.mediumText, CS.boldText, CS.blueText]}>{m.direction} {formatCurrency(m.amount)}</Text>
        </View>
      )
      )}
      <View style={[CS.rowContainer, { marginTop: 20, marginBottom: 10 }]}>
        <View style={CS.buttonLeft}>
          <Button text='Accept' onPress={() => accept} />
        </View>
        <View style={CS.buttonRight}>
          <Button text='Reject' onPress={() => reject} color='red' />
        </View>
      </View>
    </View>
  );
}

export default MilestoneChange;